import React from 'react';

import { StyleUtil } from 'ui/util';
import { NavigationContextProvider, StateContextProvider } from './context';
import { DeveloperContextProvider, useDeveloperContext } from './developer';
import { useEricssonGTM } from './hook';
import { SwitchNavigator } from './SwitchNavigator.component';
import classNames from './EABDApp.module.scss';

const SHOULD_EMULATE_ERICSSON_FRAME = process.env.NODE_ENV === 'development';

const App = React.memo(() => {
  const { init } = useEricssonGTM();
  const { shouldEmulateEricssonFrame } = useDeveloperContext();

  React.useEffect(() => init(), [init]);

  const RootClassNames = React.useMemo<string>(() => {
    const rootClassNames: string[] = [classNames.container];

    if (shouldEmulateEricssonFrame()) {
      rootClassNames.push(classNames.embeddedContainer);
    }

    return StyleUtil.mergeClassNames(rootClassNames);
  }, [shouldEmulateEricssonFrame]);

  return (
    <div className={RootClassNames}>
      <NavigationContextProvider initialScreen={'home'}>
        <StateContextProvider shouldAutoscrollJourneyAtFirst={false} shouldShowJourneyInfoDialogAtFirst={true}>
          <SwitchNavigator />
        </StateContextProvider>
      </NavigationContextProvider>
    </div>
  );
});

export const AppWithDeveloperContext = React.memo(() => {
  return (
    <DeveloperContextProvider shouldEmulateEricssonFrame={SHOULD_EMULATE_ERICSSON_FRAME}>
      <App />
    </DeveloperContextProvider>
  );
});
